// eslint-disable-next-line import/extensions
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { MergeAccountsDetails } from '@mfe/types/common';
import { html, TemplateResult } from 'lit';
import store from '@mfe/store';
import { TOGGLE_MERGE_ACCEPTED } from '@mfe/store/consents';

export const mergeAccountsWrapper = (mergeDetails: MergeAccountsDetails, innerHTML: TemplateResult, granted = false) => html`
  <one-stack gap="md">
    <one-text as="p">
      <strong>
        ${unsafeHTML(mergeDetails.headerText)}
      </strong>
    </one-text>
    <one-paper background="legal-1" padding="sm" text-color="make-links-blau">
        ${innerHTML}
    </one-paper>
    <one-cluster gap="xxs" no-wrap>
      <one-checkbox
        id="mergeCheckbox"
        name="mergeCheckbox"
        type="checkbox"
        .checked=${granted}
        variant="outline"
        @change=${() => store.dispatch({ type: TOGGLE_MERGE_ACCEPTED })}
      ></one-checkbox>
      <one-content>
        <strong>
          ${unsafeHTML(mergeDetails.checkboxText)}
        </strong>
      </one-content>
    </one-cluster>
  </one-stack>`;

export default mergeAccountsWrapper;
